import React, { useEffect } from 'react';
import { Container, Grid, Paper, Typography, List, ListItem, ListItemIcon, ListItemText, Box } from '@mui/material';
import { SportsCricket, SportsVolleyball, SportsSoccer, DirectionsRun, SportsEsports, SportsTennis, Extension,Star  } from '@mui/icons-material';
import { styled } from "@mui/material/styles";
const IconWrapper = styled(Box)(({ theme }) => ({
  width: 60,
  height: 60,
  borderRadius: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  margin: "0 auto",
  marginBottom: theme.spacing(2),
  background: theme.palette.background.paper,
  boxShadow: theme.shadows[3],
}));
const HeroBanner = () => {
    return (
        <Box 
            sx={{
                position: 'relative',
                width: '100%',
                height: { xs: '60vh', md: '80vh' },
                backgroundImage: 'url(/cricket.jpg)',  // Change this image for Sports Program
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
                color: 'white',
                '&::before': {
                    content: '""',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    background: 'rgba(0, 0, 0, 0.5)',
                }
            }}
        >
            <Container sx={{ position: 'relative', zIndex: 1 }}>
            <IconWrapper>
                        <SportsCricket color="primary" sx={{ fontSize: 30 }} />
                    </IconWrapper>
                <Typography variant="h4" sx={{ fontWeight: 'bold', mb: 2 }}>
                    NYCS Sports Program
                </Typography>
                <Typography variant="h6" sx={{ mb: 4 }}>
                    Supporting young athletes in indoor & outdoor sports.
                </Typography>
            </Container>
        </Box>
    );
};

const SportsProgram = () => {
    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to top on page load
    }, []);

    return (
        <>
            <HeroBanner />

            {/* Athletics History Section */}
            <Box sx={{ py: 5, px: 2, textAlign: 'center' }}>
                <Container maxWidth="md">
                    <Typography variant="h4" sx={{ fontWeight: 'bold', mb: 3 }}>
                        A Legacy of Indian Athletics
                    </Typography>
                    <Typography variant="body1" sx={{ fontSize: '1.1rem', color: '#555' }}>
                        Modern India can boast of a prolific history in athletics dating back to the Vedic period. 
                        India now, is literally “changing tracks” to the contemporary form of athletics. The medieval 
                        period in the history of Indian athletics, saw the advent of sports like running, jumping, and 
                        throwing which are the early ancestors of the track and field events of today's athletics.
                        Legends like Milkha Singh, Sriram Singh, P.T. Usha, and Anju Bobby George came close to changing 
                        the course of Indian Athletic history. The last decade has seen Indian athletes performing admirably 
                        at continental meets and the Commonwealth Games in long-distance running, throw, and jump events. 
                        However, success in the sprint events is still something the country yearns for.
                    </Typography>
                </Container>
            </Box>

            {/* Indoor Sports Section */}
           {/* Indoor Sports Section */}
           {/* Indoor Sports Section */}
<Box sx={{ py: 6, backgroundColor: '#f5f5f5' }}>
    <Container>
        <Typography variant="h4" sx={{ fontWeight: 'bold', mb: 3, textAlign: 'center' }}>
            Indoor Sports We Support
        </Typography>
        <Grid container spacing={4} justifyContent="center">
            {[
                { img: '/chess.png', title: 'Chess' },
                { img: '/icarrom.jpg', title: 'Carrom' },
                { icon: <SportsTennis sx={{ fontSize: 60 }} />, title: 'Table Tennis' }, // Adjust size here
            ].map((sport, index) => (
                <Grid item xs={12} sm={4} key={index}>
                    <Paper elevation={3} sx={{ p: 4, textAlign: 'center', borderRadius: 2 }}>
                        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 1, height: '60px' }}>
                            {sport.img ? (
                                <img 
                                    src={sport.img} 
                                    alt={sport.title} 
                                    style={{ width: '60px', height: '60px', objectFit: 'contain' }} 
                                />
                            ) : (
                                sport.icon
                            )}
                        </Box>
                        <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                            {sport.title}
                        </Typography>
                    </Paper>
                </Grid>
            ))}
        </Grid>
    </Container>
</Box>



            {/* Outdoor Sports Section */}
            <Box sx={{ py: 6 }}>
                <Container>
                    <Typography variant="h4" sx={{ fontWeight: 'bold', mb: 3, textAlign: 'center' }}>
                        Outdoor Sports We Support
                    </Typography>
                    <Grid container spacing={4} justifyContent="center">
                        {[
                            { icon: <SportsCricket fontSize="large" />, title: 'Cricket' },
                            { icon: <SportsVolleyball fontSize="large" />, title: 'Volleyball' },
                            { icon: <SportsSoccer fontSize="large" />, title: 'Football' },
                            { icon: <DirectionsRun fontSize="large" />, title: 'Athletics' },
                        ].map((sport, index) => (
                            <Grid item xs={12} sm={3} key={index}>
                                <Paper elevation={3} sx={{ p: 4, textAlign: 'center', borderRadius: 2 }}>
                                    <Box sx={{ fontSize: 50, mb: 1 }}>
                                        {sport.icon}
                                    </Box>
                                    <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                                        {sport.title}
                                    </Typography>
                                </Paper>
                            </Grid>
                        ))}
                    </Grid>
                </Container>
            </Box>
             {/* Support & Training Section */}
             <Box sx={{ py: 6, backgroundColor: "#fff" }}>
                <Container>
                    <Typography variant="h4" sx={{ fontWeight: 'bold', mb: 4, textAlign: "center" }}>
                        Our Support & Training
                    </Typography>
                    <List>
                        {[
                            "Professional coaching for all sports",
                            "Organized tournaments and competitions",
                            "Scholarships for talented players",
                        ].map((item, index) => (
                            <ListItem key={index}>
                                <ListItemIcon>
                                    <Star sx={{ color: "gold" }} />
                                </ListItemIcon>
                                <ListItemText primary={item} />
                            </ListItem>
                        ))}
                    </List>
                </Container>
            </Box>
        </>
    );
};

export default SportsProgram;
